<template>
  <div>
    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 40}" v-model="warnMsg" />
    <el-checkbox-group v-model="checkList" style="padding-top: 16px;" @change="change">
      <div><el-checkbox :label="check1">昵称不合格</el-checkbox></div>
      <div><el-checkbox :label="check2">头像不合格</el-checkbox></div>
      <div><el-checkbox :label="check3">自我介绍不合规</el-checkbox></div>
      <div><el-checkbox :label="check4">身份认证未通过或资料不完善</el-checkbox></div>
    </el-checkbox-group>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from "@/api/api"
import { updateResumeState } from "@/api/url";
export default {
  name: "bitchRejectDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      warnMsg: '您的信息未能通过审核，具体原因：',
      //消息前缀
      msgPrefix: '您的信息未能通过审核，具体原因：',
      warnTab: 0,
      checkList: [],
      loading: false,
      check1:{
        value: 16,
        label: '昵称不合格'
      },
      check2:{
        value: 2,
        label: '头像不合格'
      },
      check3:{
        value: 4,
        label: '自我介绍不合规'
      },
      check4:{
        value: 8,
        label: '身份认证未通过或资料不完善'
      }
    }
  },
  methods: {
    change() {
      this.warnMsg = this.msgPrefix;
      this.warnTab = 0;
      this.checkList.forEach((e)=>{
        this.warnMsg += e.label;
        this.warnMsg += '; ';
        this.warnTab += e.value;
      })
    },
    cancel() {
      this.$emit("close");
    },
    submit() {
      if (!this.warnMsg || this.warnMsg == this.msgPrefix) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入或选择不通过原因',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确认批量不通过选中的用户并发送原因').then(()=>{
        this.loading = true;
        let param = {}
        param['idArr'] = this.idArray;
        param['state'] = 3;
        param['warnMsg'] = this.warnMsg;
        param['warnTab'] = this.warnTab;
        postFormData(updateResumeState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
